export default "__VITE_ASSET__BKEd3XBU__"